import { getAuthHeaders } from "../../utils/authHeader";
import axiosInstance from "../../utils/axiosInstance";

const BASE_URL = `/organization`;

export const getOrganizationAssistantsAPI = (role, search = "") =>
  axiosInstance.get(`${BASE_URL}`, {
    ...getAuthHeaders(),
    params: {
      search,
    },
  });

export const getOnboardingAssistantsAPI = (role) =>
  axiosInstance.get(`${BASE_URL}/onboarding`, {
    ...getAuthHeaders(),
  });

export const getOrganizationUsersAPI = () => {
  return axiosInstance.get(`${BASE_URL}/users`, getAuthHeaders());
};

export const getOrganization = (uuid) => {
  return axiosInstance.get(`${BASE_URL}/${uuid}`, getAuthHeaders());
};
